import React from "react";
import classNames from "classnames";
import LoadingMutation from "./leasing.c.loadingMutation";

function Button({ className = "", children, ...props }) {
  return (
    <button
      className={classNames(
        "p-4 py-2 text-white border border-gray-200 flex items-center",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
